/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BillingRawUsageStateEnum } from './billingRawUsageStateEnum';


export interface BillingRawUsagePatchSpec { 
    data_center?: string;
    entity_id?: number;
    extrapolated?: boolean;
    info?: string;
    metric_info_id?: number;
    org_id?: string;
    processed_usage_id?: number;
    state?: BillingRawUsageStateEnum;
    usage_json?: string;
    usage_ts?: Date;
}
export namespace BillingRawUsagePatchSpec {
}


